<template>
    <div>
        <div class="background-container justify-content-between align-items-center"
             :class="{'no-eligibility': !data.eligibilitate}">
            <div class="user-info">
                <div class="text-user">
                    <p class="caen">
                        {{ data.caenPrincipal }}
                        <span>{{ secundareCount ? secundareCount : 0 }} coduri CAEN secundare eligibile</span>
                        <!--<span>(CAEN principal eligibil / {{ secundareCount ? secundareCount : 0 }} coduri CAEN secundare eligibile)</span>-->
                    </p>
                    <p class="company">Compania ta:</p>
                    <p class="company-name">{{ data.nume }}</p>
                </div>
            </div>
            <div class="top-bar-right-side mr-4">
                <div class="d-felx text-right">
                </div>
                <p class="light">Programul Operațional Competitivitate 2014-2020 - Axa Prioritara 4</p>
                <p class="mt-2">Acțiunea 4.1.1</p>
                <p>Investiții în activități productive</p>
                <p class="light">Consolidarea poziției pe piață a IMM-urilor afectate de pandemia COVID-19</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: null,
    },
    data() {
        return {
            secundareCount: 0,
        };
    },
    watch: {
        data: {
            handler: function() {
                if(this.data.caenSecundareEligibile) {
                    this.secundareCount = this.data.caenSecundareEligibile.length
                }
            },
            deep: false,
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style scoped>
.background-container {
    display: flex;
    background-image: linear-gradient(to bottom, #9dd582, #6ac096);
    width: 100%;
    padding: 20px;
}

.no-eligibility {
    background-image: linear-gradient(to bottom, #ff7070, #C45656FF);
}

.user-info {
    display: flex;
    align-items: center;
}

.text-user {
    line-height: 1.2;
}

.caen {
    font-weight: 800;
    color: #fff;
    font-size: 56px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 15px;
}

.caen span {
    font-size: 14px;
    font-weight: 500;
    text-align: left;
}

.company {
    color: #fff;
    font-size: 14px;
    margin: 0;
}

.company-name {
    font-size: 18px;
    color: #fff;
    font-weight: 600;
    margin-top: 5px;
}

.top-bar-right-side p {
    color: #fff;
    text-align: right;
}

.light {
    font-weight: 200;
}

@media only screen and (max-width: 1550px) {
    .top-bar-right-side {
        margin-left: 10px;
    }

    .top-bar-right-side p {
        font-size: 10px;
    }

    .top-bar-right-side .nume-smis {
        font-size: 12px !important;
    }

    @media (max-width: 500px) {
        .background-container {
            flex-direction: column;
        }
    }
}
@media (max-width: 1300px) {
    .background-container{
        display: block;
    }
    .top-bar-right-side{
        margin-left: 0;
        margin-top: 20px;
    }
    .top-bar-right-side p{
        text-align: left;
    }
}
</style>
